import { HTTP_TOKEN_REPORT } from "./http";

export const getCampaignsRules = (productId, params) => {
  return HTTP_TOKEN_REPORT.get(`product/${productId}/campaign/rule`, { params } ).then(result => {
    return result.data;
  });
};

export const createCampaignRule = (productId, data) => {
  return HTTP_TOKEN_REPORT.post(`product/${productId}/campaign/rule`, data).then(result => {
    return result.data;
  });
};

export const getCampaignRule = (productId, ruleId, data) => {
  return HTTP_TOKEN_REPORT.get(`product/${productId}/campaign/rule/${ruleId}`, data).then(result => {
    return result.data;
  });
};

export const updateCampaignRule = (productId, ruleId, data) => {
  return HTTP_TOKEN_REPORT.put(`product/${productId}/campaign/rule/${ruleId}`, data).then(result => {
    return result.data;
  });
};

export const deleteCampaignRule = (productId, ruleId) => {
  return HTTP_TOKEN_REPORT.delete(`product/${productId}/campaign/rule/${ruleId}`).then(result => {
    return result.data;
  });
};
